import { render, staticRenderFns } from "./m_classlive.vue?vue&type=template&id=c15440b4&scoped=true"
import script from "./m_classlive.vue?vue&type=script&lang=js"
export * from "./m_classlive.vue?vue&type=script&lang=js"
import style0 from "./m_classlive.vue?vue&type=style&index=0&id=c15440b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15440b4",
  null
  
)

export default component.exports